<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">Generación de Tarjetas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        
        <v-spacer></v-spacer>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_generarTarjetas()">
          <span v-bind:style="{ color: 'white' }">Generar PDF Tarjetas</span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col class="mr-8" cols="3" align="start">
            <v-menu :dark="dark" v-model="date1" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaDesde" label="Desde"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaDesde" @input="date1 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>

            <v-menu :dark="dark" v-model="date2" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :dark="dark" clearable dense outlined v-model="busquedaHasta" label="Hasta"
                  prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker :dark="dark" color="success" locale="es" v-model="busquedaHasta" @input="date2 = false"
                first-day-of-week="1"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col>
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="reservas" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table locale="es" v-if="reservas" dense :headers="headers" :items="reservas"
              :server-items-length="totalReservas" :options.sync="options"
              class="elevation-1 alternating-rows bordered-table" :footer-props="{
                'items-per-page-options': [20, 50, 100],
                'items-per-page-text': 'Reservas por página',
              }" @update:options="handleUpdateOptions">

              <template v-slot:[`item.codigo`]="{ item }">
                <div class="text-center" :style="{ backgroundColor: _getEstadoColorReserva(item) }"> {{ item.codigo }}
                </div>
              </template>

              <template v-slot:[`item.fechas`]="{ item }">
                <div class="fechas-container">
                  <div class="fecha-inicio">{{ formatearFecha(item.fecha_inicio) }}</div>
                  <div class="fecha-llegada">{{ formatearFecha(item.fecha_llegada) }}</div>
                </div>
              </template>


              <template v-slot:[`item.cliente_camino`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ getReservaClienteTexto(item) }}</div>
                  <div class="subtitle-2 grey--text">{{ getReservaCaminoTexto(item) }}</div>
                </div>
              </template>

              <template v-slot:[`item.cant_peregrinos`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ item.cant_peregrinos }}</div>

                </div>
              </template>


              <template v-slot:[`item.cant_habitaciones`]="{ on, item }">
                <div class="habitaciones-icon">
                  <v-icon size="28" :color="'rgb(100, 100, 100, 1)'" v-on="on">mdi-bed
                  </v-icon>
                  <span class="habitaciones-count">{{ item.cant_habitaciones }}</span>
                </div>
              </template>

              <template v-slot:[`item.comentarios`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ item.comentarios != null && item.comentarios.length > 60 ? item.comentarios.substring(0, 60) + '...' : item.comentarios }}</div>
                </div>
              </template>

              <template v-slot:no-data>
                No hay datos disponibles
              </template>


            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import {
  getReservaCaminoTitulo,
  getReservaClienteNombre,
  getReservaEstadoColor,
  getReservaEstadoNombre,
} from "@/helpers/reservaHelpers";

export default {
  components: {
    
  },

  
  data: () => ({
    headers: [
      // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      { text: 'CODIGO', value: 'codigo', sortable: false, width: '100px' },
      { text: "FECHAS", align: "left", sortable: false, value: "fechas", width: "160px" },

      { text: "CLIENTE / CAMINO", align: "left", sortable: false, value: "cliente_camino" },
      { text: "FECHA CREADA", align: "left", sortable: false, value: "created_at" },
      { text: "ORIGEN", align: "left", sortable: false, value: "origen.nombre" },
      { text: "ID", align: "center", sortable: false, value: "language", width: "20px" },
      { text: "PIL", align: "center", sortable: false, value: "cant_peregrinos", width: "35px" },
      { text: "HAB", align: "center", sortable: false, value: "cant_habitaciones", width: "35px" },

      { text: "COMENTARIOS", align: "left", sortable: false, value: "comentarios" },
    ],

    checkSoloAccion: true,

    mostrarbusqueda: true,
    date1: false,
    date2: false,

    busquedaDesde: new Date().toISOString().substr(0, 10),
    busquedaHasta: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
    fechaEntre: [new Date().toISOString().substr(0, 10), new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)],

    options: {},
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'codigo',
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",
      "colorAccent1",

      "colorAccent2",
      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("estados", ["estados"]),
    ...mapState("reservas", ["reservas", "reservaSelec", "totalReservas"]),

    reservasFiltradas() {
      return this.reservas.filter(
        (r) => this.getReservaEstadoTexto(r) != "PRESUPUESTADA"
      );

    },
  },

  watch: {
    busquedaDesde(value) {
      if (value != null && this.busquedaHasta != null) {
        this.fechaEntre[0] = value;
        this.fechaEntre[1] = this.busquedaHasta;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },

    busquedaHasta(value) {
      if (value != null && this.busquedaDesde != null) {
        this.fechaEntre[0] = this.busquedaDesde;
        this.fechaEntre[1] = value;
        this._getReservas(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },
  },

  mounted() {
    this._getReservas(true);

  },

  methods: {
    ...mapActions("reservas", ["getReservas", "getPresupuestosByTarjetas", "generarTarjetasFromListado"]),

    ...mapMutations("reservas", [
      "setDialogWidth",
      "setRutaSelec",
      "setFechaSelec",
      "setReservaSelec",
    ]),
    ...mapMutations("infoDiario", ["setDiarioFechaSelec"]),

    handleUpdateOptions(newOptions) {
      if (newOptions.page !== this.currentPage || newOptions.itemsPerPage !== this.itemsPerPage) {
        this.currentPage = newOptions.page;
        this.itemsPerPage = newOptions.itemsPerPage;
        this._getReservas(true);
      }
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      const [year, month, day] = fecha.split('-');
      const diaSemana = this.obtenerDiaSemana(fecha);
      return `${day}/${month}/${year} (${diaSemana})`;
    },

    obtenerDiaSemana(fecha) {
      const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
      const date = new Date(fecha);
      return dias[date.getDay()];
    },

    _actualizar() {
      this._getReservas(true);
    },

    _getEstadoColorReserva(reserva) {
      return getReservaEstadoColor(reserva);
    },

    getReservaClienteTexto(reserva) {
      return getReservaClienteNombre(reserva);
    },

    getReservaCaminoTexto(reserva) {
      return getReservaCaminoTitulo(reserva);
    },

    getReservaEstadoTexto(reserva) {
      return getReservaEstadoNombre(reserva);
    },

    _captionRangoFechas(fecha_inicio, fecha_llegada) {
      return fecha_inicio.split("-")[2] + '/' + fecha_inicio.split("-")[1] + " - "
        + fecha_llegada.split("-")[2] + '/' + fecha_llegada.split("-")[1];
    },

    _captionFecha(fecha, con_diasemana) {
      if (fecha) {
        return (

          fecha.substring(8, 10) +
          "-" +
          fecha.substring(5, 7) +
          "-" +
          fecha.substring(0, 4) +
          (con_diasemana ? " (" + this._diasemana(fecha) + ")" : "")
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    async _getReservas(showload) {
      const params = {};

      params.page = this.currentPage;
      params.per_page = this.itemsPerPage;
      params.sort_by = this.sortBy;

      if (this.fechaEntre[0] && this.fechaEntre[1]) {
        params.fechaEntre = this.fechaEntre;
      }

      await this.getPresupuestosByTarjetas([this.access_token, params, showload]);
    
    },

    _limpiarfiltros() {
      this.busquedaDesde = null;
      this.busquedaHasta = null;
      this.busquedaCliente = "";
      this._getReservas(true);
    },

    async _generarTarjetas() {
      const params = {};
      if (this.fechaEntre[0] && this.fechaEntre[1]) {
        params.fechaEntre = this.fechaEntre;
      }
        const pdf_url = await this.generarTarjetasFromListado([this.access_token, params, true]);

        if (pdf_url) {
          window.open(pdf_url, '_blank');
        }
    },

    
  },
};
</script>

<style scoped>
.squared-chip {
  border-radius: 0 !important;
}

.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.fixed-width-chip {
  width: 30px !important;
  justify-content: center;
}

.v-chip.v-size--small {
  height: 24px;
}

.v-chip.v-size--small .v-chip__content {
  width: 100%;
  justify-content: center;
}

.peregrinos-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.peregrinos-count {
  position: absolute;
  font-size: 14px;
  font-weight: bold;
  color: rgb(60, 60, 60);
  background-color: rgba(200, 200, 200, 1);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
  right: 7px;
}

.habitaciones-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.habitaciones-count {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: rgb(255, 255, 255);
  background-color: rgba(0, 0, 0, 1);
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -2px;
  right: -4px;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.v-menu__content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.v-list-item {
  min-height: 40px;
}

.v-list-item__title {
  font-size: 14px;
}

.v-data-table ::v-deep tbody tr {
  position: relative;
}

.estado-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  /* Ajusta este valor para cambiar el ancho de la barra */
}



</style>
